import React, { useState, useEffect } from "react";
import Modal from "../Modal";

const WorkLogModal = ({ isOpen, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    projectName: "",
    section: "",
    taskName: "",
    activityType: "",
    startTime: new Date().toISOString().slice(0, 16), // Default to now
    endTime: new Date().toISOString().slice(0, 16),
    description: "",
    billable: false,
  });

  const [activeType, setActiveType] = useState("PMS Integrated");

  useEffect(() => {
    if (isOpen) {
      setFormData({
        projectName: "",
        section: "",
        taskName: "",
        activityType: "",
        startTime: new Date().toISOString().slice(0, 16),
        endTime: new Date().toISOString().slice(0, 16),
        description: "",
        billable: false,
      });
    }
  }, [isOpen]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Basic validation
    if (!formData.taskName || !formData.startTime || !formData.endTime) {
      alert("Please fill in required fields (Task Name, Start Time, End Time)");
      return;
    }
    onSubmit(formData);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Add Work Log" size="lg">
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Work Log Type Tabs */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Work Log Type</label>
          <div className="flex gap-4">
            {["PMS Integrated", "Manual"].map((type) => (
              <label key={type} className="flex items-center cursor-pointer">
                <input
                  type="radio"
                  name="type"
                  checked={activeType === type}
                  onChange={() => setActiveType(type)}
                  className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                />
                <span className="ml-2 text-sm text-gray-700">{type}</span>
              </label>
            ))}
          </div>
        </div>

        {/* Project Name (Dropdown Mock) */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Project Name <span className="text-red-500">*</span>
          </label>
          <select
             name="projectName"
             value={formData.projectName}
             onChange={handleChange}
             className="w-full border border-gray-300 rounded-lg p-2.5 text-sm focus:ring-2 focus:ring-blue-500 outline-none bg-white"
          >
             <option value="">Select Project</option>
             <option value="VISION11">HHA Portal</option>
             <option value="WEBSITE">Main Website</option>
          </select>
        </div>

         {/* Section and Task Name */}
         <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
           {/* Section */}
           <div>
             <label className="block text-sm font-medium text-gray-700 mb-1">Section</label>
             <input
               type="text"
               name="section"
               value={formData.section}
               onChange={handleChange}
               placeholder="e.g. Frontend"
               className="w-full border border-gray-300 rounded-lg p-2.5 text-sm focus:ring-2 focus:ring-blue-500 outline-none"
             />
           </div>
           
           {/* Task Name */}
           <div>
             <label className="block text-sm font-medium text-gray-700 mb-1">
               Task Name <span className="text-red-500">*</span>
             </label>
             <input
               type="text"
               name="taskName"
               value={formData.taskName}
               onChange={handleChange}
               placeholder="Enter task name"
               className="w-full border border-gray-300 rounded-lg p-2.5 text-sm focus:ring-2 focus:ring-blue-500 outline-none"
             />
           </div>
         </div>
         
         {/* Activity Type */}
         <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Activity Type</label>
            <input
               type="text"
               name="activityType"
               value={formData.activityType}
               onChange={handleChange}
               placeholder="e.g. Development"
               className="w-full border border-gray-300 rounded-lg p-2.5 text-sm focus:ring-2 focus:ring-blue-500 outline-none"
             />
         </div>

        {/* Time Inputs */}
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Start Time <span className="text-red-500">*</span>
            </label>
            <input
              type="datetime-local"
              name="startTime"
              value={formData.startTime}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg p-2.5 text-sm focus:ring-2 focus:ring-blue-500 outline-none"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              End Time <span className="text-red-500">*</span>
            </label>
            <input
              type="datetime-local"
              name="endTime"
              value={formData.endTime}
              onChange={handleChange}
              className="w-full border border-gray-300 rounded-lg p-2.5 text-sm focus:ring-2 focus:ring-blue-500 outline-none"
            />
          </div>
        </div>

        {/* Description */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            rows="3"
            className="w-full border border-gray-300 rounded-lg p-2.5 text-sm focus:ring-2 focus:ring-blue-500 outline-none"
          ></textarea>
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-3 pt-4 border-t border-gray-100">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 text-sm font-medium transition-colors"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-sm font-medium shadow-sm transition-colors"
          >
            Save
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default WorkLogModal;
